export const VALUES = {
  delete: 'delete',
  edit: 'edit',
  move: 'move',
  more: 'more',
  send: 'send',
  triggered_start: 'triggered_start',
  triggered_termination: 'triggered_termination',
  archive: 'archive',
  unarchive: 'unarchive',
  schedule: 'schedule',
  view: 'view',
};
